export default __webpack_public_path__ + "static/media/17.9c4c766f.jpg";